/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Tab_Interview_DescInputs */

const en_landing_tab_interview_desc = /** @type {(inputs: Landing_Tab_Interview_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Practice behavioral questions with real-time AI coaching. Get feedback on STAR structure, specificity, and quantified impact — then walk into every interview prepared.`)
};

const de_landing_tab_interview_desc = /** @type {(inputs: Landing_Tab_Interview_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übe Verhaltensinterviews mit Echtzeit-KI-Coaching. Bekomme Feedback zu STAR-Struktur, Spezifik und quantifizierter Wirkung — und geh in jedes Interview vorbereitet.`)
};

const fr_landing_tab_interview_desc = /** @type {(inputs: Landing_Tab_Interview_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Practice behavioral questions with real-time AI coaching. Get feedback on STAR structure, specificity, and quantified impact — then walk into every interview prepared.`)
};

const es_landing_tab_interview_desc = /** @type {(inputs: Landing_Tab_Interview_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Practice behavioral questions with real-time AI coaching. Get feedback on STAR structure, specificity, and quantified impact — then walk into every interview prepared.`)
};

const it_landing_tab_interview_desc = /** @type {(inputs: Landing_Tab_Interview_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Practice behavioral questions with real-time AI coaching. Get feedback on STAR structure, specificity, and quantified impact — then walk into every interview prepared.`)
};

const nl_landing_tab_interview_desc = /** @type {(inputs: Landing_Tab_Interview_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Practice behavioral questions with real-time AI coaching. Get feedback on STAR structure, specificity, and quantified impact — then walk into every interview prepared.`)
};

const pl_landing_tab_interview_desc = /** @type {(inputs: Landing_Tab_Interview_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Practice behavioral questions with real-time AI coaching. Get feedback on STAR structure, specificity, and quantified impact — then walk into every interview prepared.`)
};

const fi_landing_tab_interview_desc = /** @type {(inputs: Landing_Tab_Interview_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Practice behavioral questions with real-time AI coaching. Get feedback on STAR structure, specificity, and quantified impact — then walk into every interview prepared.`)
};

const da_landing_tab_interview_desc = /** @type {(inputs: Landing_Tab_Interview_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Practice behavioral questions with real-time AI coaching. Get feedback on STAR structure, specificity, and quantified impact — then walk into every interview prepared.`)
};

const sv_landing_tab_interview_desc = /** @type {(inputs: Landing_Tab_Interview_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Practice behavioral questions with real-time AI coaching. Get feedback on STAR structure, specificity, and quantified impact — then walk into every interview prepared.`)
};

/**
* | output |
* | --- |
* | "Practice behavioral questions with real-time AI coaching. Get feedback on STAR structure, specificity, and quantified impact — then walk into every interview..." |
*
* @param {Landing_Tab_Interview_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_tab_interview_desc = /** @type {((inputs?: Landing_Tab_Interview_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Tab_Interview_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_tab_interview_desc(inputs)
	if (locale === "fr") return fr_landing_tab_interview_desc(inputs)
	if (locale === "es") return es_landing_tab_interview_desc(inputs)
	if (locale === "it") return it_landing_tab_interview_desc(inputs)
	if (locale === "nl") return nl_landing_tab_interview_desc(inputs)
	if (locale === "pl") return pl_landing_tab_interview_desc(inputs)
	if (locale === "fi") return fi_landing_tab_interview_desc(inputs)
	if (locale === "da") return da_landing_tab_interview_desc(inputs)
	if (locale === "sv") return sv_landing_tab_interview_desc(inputs)
	return en_landing_tab_interview_desc(inputs)
});